import { RESET_REPLY_CONTENT, SET_REPLY_CONTENT } from "../actions/chatAction";
import { ReplyContentType } from "../pages/chats/types";

const defaultState = {
  chatReplyContent: null as ReplyContentType | null,
};

export const chatReducer = (state = defaultState, action: any) => {
  const { type, data } = action;

  if (type === SET_REPLY_CONTENT) return { ...state, chatReplyContent: data };
  if (type === RESET_REPLY_CONTENT) return { ...state, chatReplyContent: null };
  return state;
};
